import { documentInstancesSagas } from './documentInstances'
import { documentTemplatesSagas } from './documentTemplates'
import { filesSagas } from './files'
import { userMeTeamsSagas } from './users'
import { questionInstancesSagas } from './questionInstances'
import { medicalEventsSagas } from './medicalEvents'
import { resourceHistorySagas } from './resourceHistory'

export const cacheSagas = [
  ...Object.values(documentInstancesSagas),
  ...Object.values(documentTemplatesSagas),
  ...Object.values(filesSagas),
  ...Object.values(medicalEventsSagas),
  ...Object.values(questionInstancesSagas),
  ...Object.values(resourceHistorySagas),
  ...Object.values(userMeTeamsSagas),
]
